module.exports = __webpack_public_path__ + "img/Mask Group 2918@2x.f53f7451.png";